__turbopack_context__.v({
  "fadeInOut": "style-module__HhmfuG__fadeInOut",
  "notification": "style-module__HhmfuG__notification",
});
